import React from 'react';

const SmallArrowRight = () => {
  return (
    <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.329505 17.6234C-0.109835 17.1213 -0.109835 16.3073 0.329505 15.8051L6.28401 9L0.329505 2.19485C-0.109835 1.69275 -0.109835 0.878679 0.329505 0.376577C0.768845 -0.125526 1.48116 -0.125526 1.9205 0.376577L8.6705 8.09086C9.10983 8.59297 9.10983 9.40703 8.6705 9.90914L1.9205 17.6234C1.48116 18.1255 0.768845 18.1255 0.329505 17.6234Z"
        fill="#212121"
      />
    </svg>
  );
};

export { SmallArrowRight };
